import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { container, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledContainer = styled.div`
  margin: auto;
  padding: ${spacing('md')};
  max-width: ${container('xl')};
  width: 100%;
  background-image: url('${getPublicPath('/images/comparison/cta-bg.svg')}');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left top;
  overflow: hidden;

  @media (min-width: ${screen('md')}) {
    background-position: center center;
  }
`;

export const StyledContent = styled.div`
  max-width: ${container('xs')};
  position: relative;

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl6')};
    padding-bottom: ${spacing('xl6')};
    padding-left: ${spacing('xl')};
  }

  @media (min-width: ${screen('lg')}) {
    padding-left: ${spacing('xl7')};
    max-width: ${container('md')};
  }

  &::after {
    content: '';
    position: absolute;
    right: 0rem;
    top: -2.5rem;
    width: 5rem;
    height: 5.5rem;
    background-image: url('${getPublicPath('/images/comparison/planet.svg')}');
    background-size: contain;

    @media (min-width: ${screen('md')}) {
      right: -17rem;
      top: 2rem;
      width: 15rem;
      height: 16rem;
    }
  }

  ${Heading2} {
    @media (max-width: ${screen('mdMax')}) {
      padding-right: ${spacing('xl4')};
      margin-top: ${spacing('xl3')};
    }
  }
`;
